export enum MatTableExporterOutputFileType {
  XLSX = 'xlsx',
  CSV = 'csv',
}
